import { useIntl } from 'react-intl';

import { MAIN_CONTENT_ID } from '@/components/accessibility/SkipToMain';
import { FamilyPlanLandingProps } from '@/components/familyPlan/FamilyPlanLanding/types';
import GridWrapper from '@/components/ui/GridWrapper';

import { featureItems } from './data';
import messages from './messages';
import {
	CircleCheck,
	FeatureBackground,
	FeatureHeading,
	FeatureList,
	FeatureRow,
	FeatureText,
	Heading,
	Subheading,
	Wrapper,
} from './styles';

const Unlock = ({ isJoinFlow }: Omit<FamilyPlanLandingProps, 'onClick'>) => {
	const { formatMessage } = useIntl();

	return (
		<Wrapper>
			<GridWrapper columns={3} id={MAIN_CONTENT_ID}>
				<Heading>{formatMessage(messages.heading)}</Heading>
				<Subheading>{formatMessage(isJoinFlow ? messages.subheadingAccept : messages.subheading)}</Subheading>
				{featureItems.length > 0 && (
					<FeatureList>
						<FeatureBackground />
						<FeatureRow>
							<div />
							<FeatureHeading>{formatMessage(messages.basicHeading)}</FeatureHeading>
							<FeatureHeading>{formatMessage(messages.premiumHeading)}</FeatureHeading>
						</FeatureRow>
						{featureItems.map(feature => {
							return (
								<FeatureRow key={formatMessage(feature.description)}>
									<FeatureText>{formatMessage(feature.description)}</FeatureText>
									{feature.isLimitedLabel && <FeatureText>{formatMessage(messages.limitedText)}</FeatureText>}
									{feature.isLimitedCheck && (
										<div>
											<CircleCheck $isGray />
										</div>
									)}
									{!feature.isLimitedLabel && !feature.isLimitedCheck && <div />}
									{feature.isUnlimitedLabel ? (
										<FeatureText>{formatMessage(messages.unlimitedText)}</FeatureText>
									) : (
										<div>
											<CircleCheck />
										</div>
									)}
								</FeatureRow>
							);
						})}
					</FeatureList>
				)}
			</GridWrapper>
		</Wrapper>
	);
};

export default Unlock;
